import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { GrNext } from "react-icons/gr";
import {
  Box,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import styles from "../Candidate.module.css";
import {
  customTextColor,
  formatArrayString,
  formatDate,
  formatTime,
  ShortenName2,
  splitIntoColumns,
} from "../../../utils/const";
import React, { useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { PiChairLight } from "react-icons/pi";
import { PiAddressBookLight } from "react-icons/pi";
import { PiIdentificationCardLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { PiUserLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { allSkill } from "../../../redux/common/skillSlice";
import {
  getAllCandidate,
  getAllRequirementCountForCandidate,
  getOneCandidate,
  mutualCandidateProfile,
  resumeStatusChange,
  resumeStatusChangeAdd,
  resumeStatusChangeDelete,
  updateActionCandidateProfile,
  updateExistCandidateProfile,
  viewSearchCandidate,
} from "../../../redux/candidate/candidateSlice";
import Resume from "../../../assets/images/Resume - Profile.png";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import CandidateSubmisionDrawer from "./CandidateSubmisionDrawer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getProfile } from "../../../redux/profile/profileSlice";
import StatusChangeDrawer from "./StatusChangesDrawer";
import InternalTrackerCommentDrawer from "../../../screens/InternalTracker/Candidate/InternalTrackerCommentDrawer";
import { Icon } from "@iconify/react/dist/iconify.js";
import CandidateCommentDrawer from "./CandidateCommentDrawer";
import SideFlexScreen from "../../../components/containers/SideFlexScreen";

const CandidateViewDrawer = ({ handleClose, show, row, handleOpennnn }) => {
  const [showComments, setShowComment] = useState(false);
  const [open, setOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [actionName, setActionName] = useState("");
  const [jobStatusName, setJobStatusName] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const handleCloseShowDetails = () => setShowDetails(false);
  const handleShowDetails = () => setShowDetails(true);
  const handleCloseShowStatus = () => setShowStatus(false);
  const handleShowStatus = () => setShowStatus(true);
  const [showAll, setShowAll] = useState(false);
  const handleCloseCommentShow = () => setShowComment(false);
  const handleCommentShow = () => setShowComment(true);
  const toggleView = () => {
    setShowAll((prev) => !prev);
  };
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];
  const skillData = useSelector((state) => state.skill.data);
  const singleCandidateData = useSelector(
    (state) => state.candidate.singleCandidateData
  );
  const mutualCandidate = useSelector(
    (state) => state.candidate.mutualCandidate
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const candidatesStatus = useSelector(
    (state) => state.candidate.singleCandidateStatus
  );
  const singleCandidateStatus = useSelector(
    (state) => state.candidate.singleCandidateStatus
  );

  // const [data, setData] = useState(
  //   location.state || JSON.parse(localStorage.getItem("candidateDetails"))
  // );

  // useEffect(() => {
  //   if (location.state) {
  //     localStorage.setItem("candidateDetails", JSON.stringify(location.state));
  //     setData(location.state);
  //   }
  // }, [location.state]);

  useEffect(() => {
    dispatch(allSkill());
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, [dispatch]);

  const handleSelect = (value) => {
    setActionName(value);
    if (value === false) {
      handleShowStatus();
      let userData = {
        resume_profile_id: row?.id,
        active: false,
      };
      dispatch(resumeStatusChange(userData));
    } else {
      handleOpenAction();
    }
  };

  const matchingSkills = skillData?.locations?.filter((skill) =>
    row?.skills?.includes(skill.id)
  );
  const columns = splitIntoColumns(matchingSkills, 4);

  const matchingSkills2 = skillData?.locations?.filter((skill) =>
    row?.secondary_skills?.includes(skill.id)
  );
  const columns2 = splitIntoColumns(matchingSkills2, 4);

  useEffect(() => {
    if (singleCandidateData) {
      let quiry = singleCandidateData?.profile?.id;
      dispatch(getAllRequirementCountForCandidate(quiry));
    }
  }, [singleCandidateData]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleOpenAction = () => {
    setOpenAction(true);
  };

  const handleCloseAction = () => {
    setOpenAction(false);
  };

  const handleOnChangeAction = (name) => {
    setActionName(name);
  };

  useEffect(() => {
    if (candidatesStatus === "update_candidate_action") {
      let ID = row?.id;
      dispatch(getOneCandidate(ID));
      dispatch(getAllCandidate());
      handleCloseModal();
      handleCloseAction();
      setJobStatusName(singleCandidateData?.profile?.active);
    }
  }, [candidatesStatus, singleCandidateData]);

  console.log({ jobStatusName });

  useEffect(() => {
    if (row) {
      setActionName(row?.active);
      setJobStatusName(row?.active);
    }
  }, [row]);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };
  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const whichStatus = (value) => {
    let status;
    if (value === true) {
      status = "Active";
    } else {
      status = "In-Active";
    }
    return status;
  };

  useEffect(() => {
    if (row) {
      let ID = row?.id;
      let email = row?.email;
      dispatch(getOneCandidate(ID));
      dispatch(viewSearchCandidate(ID));
      dispatch(mutualCandidateProfile(email));
    }
  }, [row]);

  const handleClickOnActive = () => {
    let userData = {
      active: true,
      resume_profile_id: row?.id,
      candidate: row?.candidate,
      full_name: row?.full_name,
      prefer_tax_team: row?.prefer_tax_team,
      recruiter_user_id: row?.recruiter_user_id,
    };
    dispatch(updateActionCandidateProfile(userData));
  };

  useEffect(() => {
    if (singleCandidateStatus === "delete_resume_status_success") {
      handleCloseAction();
      // } else if (singleCandidateStatus === "add_resume_status_add_success") {
      //   handleCloseModal();
    } else if (singleCandidateStatus === "add_resume_status_add_success") {
      let ID = row?.id;
      dispatch(getOneCandidate(ID));
      handleCloseShowStatus();
    }
  }, [singleCandidateStatus]);

  console.log({ singleCandidateData });

  const resumeStatuses =
    singleCandidateData?.profile_status?.current_recruiter?.flatMap(
      (item) => item?.resume_statuses
    );

  const resumeStatusesOther =
    singleCandidateData?.profile_status?.other_recruiters?.flatMap(
      (item) => item?.resume_statuses
    );

  console.log({ singleCandidateData });

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        scroll={false}
        backdrop={false}
        style={{
          border: "none",
          marginTop: "74px",
          width: "65%",
          // padding: "0 0 0 10px",
          backgroundColor: "#f5f5f5",
          boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Offcanvas.Header
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fff",
            padding: "3px 10px 3px 0",
            margin: "0 15px",
          }}
        >
          <Box
            className={styles.job_serach_result_heading}
            sx={{ margin: "0" }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <GrNext
                style={{
                  fontSize: "22px",
                  cursor: "pointer",
                  color: customTextColor,
                  marginRight: "20px",
                }}
                onClick={handleClose}
              />

              <span onClick={() => setShowComment(!showComments)}>
                <span
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#e4e6eb",
                    padding: "6px 8px",
                    borderRadius: "2px",
                    color: "rgb(76, 104, 176)",
                  }}
                >
                  <Icon
                    icon="teenyicons:message-plus-outline"
                    height={20}
                    width={20}
                  />
                </span>
                <span
                  style={{ textDecoration: "underline", fontWeight: "600" }}
                >
                  Add Comment{" "}
                </span>
              </span>
            </Box>
          </Box>
          <BsThreeDotsVertical
            style={{
              fontSize: "22px",
              cursor: "pointer",
              color: customTextColor,
            }}
            onClick={handleShowDetails}
          />
        </Offcanvas.Header>
        <Offcanvas.Body style={{ padding: "0" }}>
          {singleCandidateStatus === "loading" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 230,
              }}
            >
              <CircularProgress size={30} color="info" />
            </Box>
          ) : (
            <Box className={styles.candidate_structure}>
              <Box className={styles.profile_and_submit}>
                <Box>
                  <Typography>
                    Activities Since:{" "}
                    <b>
                      {singleCandidateData?.profile?.created_at !== undefined &&
                        formatDate(singleCandidateData?.profile?.created_at)}
                    </b>
                  </Typography>
                  {/* <Typography onClick={handleOpennnn}>
                    <b>Profile Credited by</b>
                  </Typography> */}
                  <Tooltip
                    title={
                      <React.Fragment>
                        {mutualCandidate?.mutual_recruiters?.map((cand) => {
                          return <Typography>{cand?.fullName}</Typography>;
                        })}
                      </React.Fragment>
                    }
                  >
                    <Typography onClick={handleOpennnn}>
                      Mutual Active :{" "}
                      <b>
                        {" "}
                        {mutualCandidate?.mutual_recruiters !== undefined &&
                        mutualCandidate?.mutual_recruiters?.length > 0
                          ? mutualCandidate?.mutual_recruiters?.length
                          : 0}{" "}
                      </b>
                    </Typography>
                  </Tooltip>
                </Box>
                <a
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    textDecoration: "none",
                    color: "#374151",
                  }}
                  href={singleCandidateData?.profile?.resume}
                  target="_blank"
                >
                  <Box className={styles.phase2}>
                    <img
                      src={Resume}
                      alt="attachment"
                      style={{
                        width: "50px",
                        backgroundColor: "#e1eaf0",
                        padding: "6px",
                        borderRadius: "3px",
                      }}
                    />
                    <Typography sx={{ marginTop: "5px" }}>
                      Get Resume
                    </Typography>
                  </Box>
                </a>
              </Box>
              <Grid
                container
                className={styles.profile_phase}
                sx={{ backgroundColor: "#fff", marginBottom: "15px" }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{
                    border: "none !important",
                    marginBottom: "15px !important",
                  }}
                >
                  <Typography sx={{ marginLeft: "0 !important" }}>
                    <PiUserLight
                      style={{
                        fontSize: "33px",
                        backgroundColor: "#f2f2f2",
                        padding: "4px",
                        borderRadius: "3px",
                        color: "#4c68b0",
                      }}
                    />

                    <b style={{ marginLeft: "10px" }}>
                      {" "}
                      {singleCandidateData?.profile?.full_name}
                    </b>
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ marginBottom: "15px !important" }}
                >
                  <Typography>
                    {" "}
                    <PiChairLight
                      style={{
                        fontSize: "33px",
                        backgroundColor: "#f2f2f2",
                        padding: "4px",
                        borderRadius: "3px",
                        color: "#4c68b0",
                      }}
                    />
                    <b style={{ marginLeft: "10px" }}>
                      {ShortenName2(
                        singleCandidateData?.profile?.current_job_title
                      )}{" "}
                    </b>
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Typography sx={{ marginLeft: "0 !important" }}>
                    <PiAddressBookLight
                      style={{
                        fontSize: "33px",
                        backgroundColor: "#f2f2f2",
                        padding: "4px",
                        borderRadius: "3px",
                        color: "#4c68b0",
                      }}
                    />

                    <b style={{ marginLeft: "10px" }}>
                      {singleCandidateData?.profile?.total_experience} Years’
                      Experience
                    </b>
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ color: customTextColor }}
                >
                  <Typography>
                    <PiIdentificationCardLight
                      style={{
                        fontSize: "33px",
                        backgroundColor: "#f2f2f2",
                        padding: "4px",
                        borderRadius: "3px",
                        color: "#4c68b0",
                      }}
                    />

                    <b style={{ marginLeft: "10px" }}>
                      {getWorkAuthorization(
                        singleCandidateData?.profile?.work_authorization
                      )}
                    </b>
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                className={styles.profile_details_view}
                sx={{ color: customTextColor, margiTop: "10px" }}
              >
                <Grid
                  item
                  md={6}
                  lg={6}
                  sx={{ display: "block !important" }}
                  className={styles.profile_details_views}
                >
                  <ul
                    style={{
                      listStyleType: "square",
                      padding: "5px 20px",
                      marginBottom: "10px",
                    }}
                  >
                    <li>
                      <Typography>
                        Current Location:{" "}
                        <b>
                          {getLocationById(
                            singleCandidateData?.profile?.current_location
                          )}
                        </b>
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        Tax Term:{" "}
                        <b>
                          {singleCandidateData?.profile?.p_tax_team !==
                            undefined &&
                            formatArrayString(
                              singleCandidateData?.profile?.p_tax_team
                            )}
                        </b>
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        Work Preference:{" "}
                        <b>{singleCandidateData?.profile?.work_preference}</b>
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        Passing Year:{" "}
                        <b>{singleCandidateData?.profile?.passing_year}</b>
                      </Typography>
                    </li>

                    <li style={{ marginBottom: "0 !important" }}>
                      <Typography>
                        Qualifications:{" "}
                        <b>
                          {" "}
                          {
                            singleCandidateData?.profile?.highest_qualification
                          }{" "}
                        </b>
                      </Typography>
                    </li>
                  </ul>
                </Grid>

                <Grid
                  item
                  md={6}
                  lg={6}
                  // sx={{ display: "block !important" }}
                  sx={{
                    color: customTextColor,
                    position: "relative",
                    overflow: "visible",
                    alignSelf: "baseline",
                  }}
                  className={styles.profile_details_views}
                >
                  <ul
                    style={{
                      listStyleType: "square",
                      padding: "5px 20px",
                      marginBottom: "10px",
                    }}
                  >
                    <li>
                      <Typography>
                        Prefer Location:{" "}
                        <b>
                          {getPreferLocationNames(
                            singleCandidateData?.profile?.prefer_location
                          )}
                        </b>
                      </Typography>
                    </li>

                    <li>
                      <Typography>
                        Rate:{" "}
                        <b> ${singleCandidateData?.profile?.rate} Hourly </b>
                      </Typography>
                    </li>

                    {/*
                    <li>
                      <Typography>
                        <b>{singleCandidateData?.profile?.current_company}</b>
                      </Typography>
                    </li>
                  */}

                    <li>
                      <Typography>
                        University:
                        <b> {singleCandidateData?.profile?.university} </b>
                      </Typography>
                    </li>

                    <li style={{ marginBottom: "0 !important" }}>
                      <Typography>
                        Linked in Profile:{" "}
                        <b>
                          {" "}
                          {singleCandidateData?.profile?.linkedin_profile_url}
                        </b>
                      </Typography>
                    </li>
                  </ul>
                  <SideFlexScreen userInfo={singleCandidateData?.profile} />
                </Grid>
              </Grid>

              <Grid
                container
                sx={{ backgroundColor: "#fff", margin: "14px 0" }}
              >
                <Grid item xs={12}>
                  <Box className={styles.list_details}>
                    <Typography sx={{ marginBottom: "20px !important" }}>
                      <b>Primary skills</b>
                    </Typography>
                    <Grid container sx={{ fontWeight: "600" }}>
                      {columns.map((column, colIndex) => (
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={3}
                          lg={3}
                          key={colIndex}
                          sx={{
                            borderLeft:
                              colIndex !== 0 ? "2px solid white" : "none",
                            paddingLeft: colIndex !== 0 ? "20px" : "0",
                          }}
                        >
                          <Box sx={{ color: customTextColor }}>
                            {column.map((skill) => (
                              <Typography
                                key={skill.id}
                                sx={{ marginBottom: "0 !important" }}
                              >
                                {skill.name}
                              </Typography>
                            ))}
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Grid
                container
                sx={{ backgroundColor: "#fff", margin: "14px 0" }}
              >
                <Grid item xs={12}>
                  <Box className={styles.list_details}>
                    <Typography sx={{ marginBottom: "20px !important" }}>
                      <b>Secondary skills</b>
                    </Typography>
                    <Grid container sx={{ fontWeight: "600" }}>
                      {columns2.map((column, colIndex) => (
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={3}
                          lg={3}
                          key={colIndex}
                          sx={{
                            borderLeft:
                              colIndex !== 0 ? "2px solid white" : "none",
                            paddingLeft: colIndex !== 0 ? "20px" : "0",
                          }}
                        >
                          <Box sx={{ color: customTextColor }}>
                            {column.map((skill) => (
                              <Typography
                                key={skill.id}
                                sx={{ marginBottom: "0 !important" }}
                              >
                                {skill.name}
                              </Typography>
                            ))}
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
              <Box className={styles.experience_details}>
                <Box>
                  <Typography sx={{ fontSize: "18px !important" }}>
                    <b>Professional Experience</b>
                  </Typography>
                </Box>
              </Box>
              {singleCandidateData?.profile?.previous_experience ? (
                JSON?.parse(
                  singleCandidateData?.profile?.previous_experience
                )?.map((prevData, index) => {
                  return (
                    <Box className={styles.full_details}>
                      <Box sx={{ marginLeft: "20px" }}>
                        <Typography>
                          <b>{prevData?.role}</b>
                        </Typography>
                        <Typography>{prevData?.company}</Typography>
                        <Typography>
                          {prevData?.industry_of_the_company}
                        </Typography>
                        <Typography
                          sx={{
                            display: "flex",
                            justifyContent: "end",
                            position: "relative",
                            bottom: "60px",
                            marginTop: "10px",
                          }}
                        >
                          {prevData?.duration_from} to {prevData?.duration_to}
                        </Typography>
                      </Box>
                      <ul>
                        {prevData?.summary_of_work.map((text, index) => (
                          <li key={index}>{text}</li>
                        ))}
                      </ul>
                    </Box>
                  );
                })
              ) : (
                <p>No Experience Found</p>
              )}

              {singleCandidateData?.profile?.referrer_company_name === "" &&
              singleCandidateData?.profile?.referrer_email === "" &&
              singleCandidateData?.profile?.referrer_manager_name === "" &&
              singleCandidateData?.profile?.referrer_mobile_no === "" ? (
                ""
              ) : (
                <Grid
                  container
                  className={styles.candidates_name}
                  sx={{ marginBottom: "14px" }}
                >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Grid
                      container
                      className={styles.requirement_details_view}
                      sx={{ color: customTextColor, padding: "10px" }}
                    >
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <span>
                          <Box>
                            <PiUserLight
                              style={{
                                fontSize: "33px",
                                backgroundColor: "#f2f2f2",
                                padding: "4px",
                                borderRadius: "3px",
                              }}
                            />
                            <Typography>
                              Manager Name:{" "}
                              <b>
                                {
                                  singleCandidateData?.profile
                                    ?.referrer_manager_name
                                }
                              </b>
                            </Typography>
                          </Box>
                          <Box sx={{ marginBottom: "0 !important" }}>
                            <PiMailboxLight
                              style={{
                                fontSize: "33px",
                                backgroundColor: "#f2f2f2",
                                padding: "4px",
                                borderRadius: "3px",
                              }}
                            />
                            <Typography>
                              Email ID :
                              <b>
                                {" "}
                                {
                                  singleCandidateData?.profile?.referrer_email
                                }{" "}
                              </b>
                            </Typography>
                          </Box>
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <span>
                          <Box>
                            <PiBuildingOfficeLight
                              style={{
                                fontSize: "33px",
                                backgroundColor: "#f2f2f2",
                                padding: "4px",
                                borderRadius: "3px",
                              }}
                            />
                            <Typography>
                              Company Name:{" "}
                              <b>
                                {
                                  singleCandidateData?.profile
                                    ?.referrer_company_name
                                }
                              </b>
                            </Typography>
                          </Box>

                          <Box sx={{ marginBottom: "0 !important" }}>
                            <CiMobile3
                              style={{
                                fontSize: "33px",
                                backgroundColor: "#f2f2f2",
                                padding: "4px",
                                borderRadius: "3px",
                              }}
                            />
                            <Typography>
                              Phone No:{" "}
                              <b>
                                {
                                  singleCandidateData?.profile
                                    ?.referrer_mobile_no
                                }{" "}
                              </b>
                            </Typography>
                          </Box>
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {singleCandidateData?.profile?.referrer_company_name2 === "" &&
              singleCandidateData?.profile?.referrer_email2 === "" &&
              singleCandidateData?.profile?.referrer_manager_name2 === "" &&
              singleCandidateData?.profile?.referrer_mobile_no2 === "" ? (
                ""
              ) : (
                <Grid
                  container
                  className={styles.candidates_name}
                  sx={{ marginBottom: "14px" }}
                >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Grid
                      container
                      className={styles.requirement_details_view}
                      sx={{ color: customTextColor, padding: "10px" }}
                    >
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <span>
                          <Box>
                            <PiUserLight
                              style={{
                                fontSize: "33px",
                                backgroundColor: "#f2f2f2",
                                padding: "4px",
                                borderRadius: "3px",
                              }}
                            />
                            <Typography>
                              Manager Name:{" "}
                              <b>
                                {
                                  singleCandidateData?.profile
                                    ?.referrer_manager_name2
                                }
                              </b>
                            </Typography>
                          </Box>
                          <Box sx={{ marginBottom: "0 !important" }}>
                            <PiMailboxLight
                              style={{
                                fontSize: "33px",
                                backgroundColor: "#f2f2f2",
                                padding: "4px",
                                borderRadius: "3px",
                              }}
                            />
                            <Typography>
                              Email ID :
                              <b>
                                {" "}
                                {
                                  singleCandidateData?.profile?.referrer_email2
                                }{" "}
                              </b>
                            </Typography>
                          </Box>
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <span>
                          <Box>
                            <PiBuildingOfficeLight
                              style={{
                                fontSize: "33px",
                                backgroundColor: "#f2f2f2",
                                padding: "4px",
                                borderRadius: "3px",
                              }}
                            />
                            <Typography>
                              Company Name:{" "}
                              <b>
                                {
                                  singleCandidateData?.profile
                                    ?.referrer_company_name2
                                }
                              </b>
                            </Typography>
                          </Box>

                          <Box sx={{ marginBottom: "0 !important" }}>
                            <CiMobile3
                              style={{
                                fontSize: "33px",
                                backgroundColor: "#f2f2f2",
                                padding: "4px",
                                borderRadius: "3px",
                              }}
                            />
                            <Typography>
                              Phone No:{" "}
                              <b>
                                {
                                  singleCandidateData?.profile
                                    ?.referrer_mobile_no2
                                }{" "}
                              </b>
                            </Typography>
                          </Box>
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {resumeStatuses?.length > 0 && (
                <Grid
                  container
                  className={styles.candidates_name}
                  sx={{ marginBottom: "14px" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    sx={{ backgroundColor: "#fff", padding: "10px" }}
                  >
                    <div>
                      <h6>Current Recruiter Resume Statuses</h6>
                      <ul>
                        {resumeStatuses?.map((status) => {
                          return (
                            <li key={status.id}>
                              <strong>Job Role:</strong> {status.job_title}{" "}
                              <br />
                              <strong>Reason For Status Change:</strong>{" "}
                              {status.reason_for_status_change} <br />
                              <strong>Duration:</strong> {status.duration}{" "}
                              <br />
                              <strong>Recruiter:</strong>{" "}
                              {status.recruiter_name} <br />
                              <strong>Company:</strong> {status.company} <br />
                              <strong>Notes:</strong> {status.notes || "N/A"}{" "}
                              <br />
                              <strong>Date:</strong>{" "}
                              {formatDate(status?.created_at)},
                              {formatTime(status?.created_at)} <br />
                              <hr />
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              )}

              {resumeStatusesOther?.length > 0 && (
                <Grid
                  container
                  className={styles.candidates_name}
                  sx={{ marginBottom: "14px" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    sx={{ backgroundColor: "#fff", padding: "10px" }}
                  >
                    <div>
                      <h6>Current Recruiter Resume Statuses For Other</h6>
                      <ul>
                        {resumeStatusesOther?.length > 0 &&
                          resumeStatusesOther?.map((status) => {
                            return (
                              <li key={status.id}>
                                <strong>Job Role:</strong> {status.job_title}{" "}
                                <br />
                                <strong>Reason For Status Change:</strong>{" "}
                                {status.reason_for_status_change} <br />
                                <strong>Duration:</strong> {status.duration}{" "}
                                <br />
                                <strong>Recruiter:</strong>{" "}
                                {status.recruiter_name} <br />
                                <strong>Company:</strong> {status.company}{" "}
                                <br />
                                <strong>Notes:</strong> {status.notes || "N/A"}{" "}
                                <br />
                                <strong>Date:</strong>{" "}
                                {formatDate(status?.created_at)},
                                {formatTime(status?.created_at)}
                                <br />
                                <hr />
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              )}

              <Box className={styles.internal_update_btns}>
                <Box className={styles.add_back_btns}>
                  <button
                    onClick={handleClose}
                    style={{
                      border: "1.5px solid #4285f4",
                      marginRight: "10px",
                      padding: "4.5px 10px ",
                    }}
                  >
                    <IoIosArrowRoundBack
                      style={{ fontSize: "25px", color: "#4285f4" }}
                    />
                  </button>
                </Box>
                <Box>
                  <div className="btn-group">
                    <button
                      type="button"
                      className="dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{
                        color: "black",
                        width: "7rem",
                        border: "1.5px solid #4287f5",
                        padding: "6px 10px",
                      }}
                    >
                      {whichStatus(actionName)}
                    </button>
                    <div className="dropdown-menu">
                      <a
                        className="dropdown-item"
                        style={
                          jobStatusName === true
                            ? {
                                backgroundColor: "#fff",
                                pointerEvents: "none",
                                opacity: "0.5",
                                cursor: "not-allowed ",
                              }
                            : { backgroundColor: "#fff" }
                        }
                        onClick={() => handleSelect(true)}
                      >
                        Active
                      </a>
                      <a
                        className="dropdown-item"
                        style={
                          jobStatusName === false
                            ? {
                                backgroundColor: "#fff",
                                pointerEvents: "none",
                                opacity: "0.5",
                                cursor: "not-allowed ",
                              }
                            : { backgroundColor: "#fff" }
                        }
                        onClick={() => handleSelect(false)}
                      >
                        In-Active
                      </a>
                    </div>
                  </div>
                </Box>
              </Box>
            </Box>
          )}

          <Dialog
            fullScreen={fullScreen}
            open={openAction}
            // onClose={handleCloseAction}
            maxWidth="sm"
            aria-labelledby="responsive-dialog-title"
            fullWidth={true}
          >
            <Box>
              <DialogContent sx={{ textAlign: "center" }}>
                <Box>
                  <b>Are you sure to Active This Candidate</b>
                </Box>

                {/* <Typography sx={{ marginTop: "20px" }}>
                  Note : If you Active this Candidate then previous all job
                  status will remove forever
                </Typography> */}
              </DialogContent>
              <Box>
                <Box className={styles.adding_internal_btns}>
                  <button
                    sx={{ backgroundColor: "#2d73b5" }}
                    // onClick={handleOnClickStatusChange}
                    onClick={handleClickOnActive}
                  >
                    Submit
                  </button>
                  <button
                    sx={{ backgroundColor: "#97B6F1" }}
                    onClick={handleCloseAction}
                  >
                    Cancel
                  </button>
                </Box>
              </Box>
            </Box>
          </Dialog>
        </Offcanvas.Body>
        <CandidateSubmisionDrawer
          handleShow={handleShowDetails}
          handleClose={handleCloseShowDetails}
          show={showDetails}
          row={singleCandidateData}
          getPreferLocationNames={getPreferLocationNames}
        />

        <StatusChangeDrawer
          handleShow={handleShowStatus}
          handleClose={handleCloseShowStatus}
          show={showStatus}
          row={row}
          singleCandidateStatus={singleCandidateStatus}
        />
        <CandidateCommentDrawer
          handleShow={handleCommentShow}
          handleClose={handleCloseCommentShow}
          show={showComments}
          candidateDetails={singleCandidateData}
        />
      </Offcanvas>
    </>
  );
};

export default CandidateViewDrawer;
